import { render, staticRenderFns } from "./footer-sns.vue?vue&type=template&id=bd785174&scoped=true&"
import script from "./footer-sns.vue?vue&type=script&lang=js&"
export * from "./footer-sns.vue?vue&type=script&lang=js&"
import style0 from "./footer-sns.vue?vue&type=style&index=0&id=bd785174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd785174",
  null
  
)

export default component.exports